export const passwordIconButtonSx = { '&:hover': { backgroundColor: 'transparent' } } as const;
